import { useRef } from "react";
import cx from "classnames";
import { capitalize } from "es-toolkit/string";
import SelectPopover from "src/components/input/SelectPopover/SelectPopover";
import { useSize } from "src/hooks/useSize";
import type { GroupType } from "../../../../ComparativeAnalysisForm.types";
import { parseTask } from "../../../ComparativeAnalysisFormTask/ComparativeAnalysisFormTask.utils";

interface ComparativeAnalysisFormSelectPopoverProps {
  type: "base" | "compare";
  group: GroupType;
  className?: string;
}

const ComparativeAnalysisFormSelectPopover = ({
  type,
  group,
  className,
}: ComparativeAnalysisFormSelectPopoverProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const containerSize = useSize(ref);
  const isNarrowContainer = containerSize?.width < 400;

  const label = (
    <div
      ref={ref}
      className="flex items-stretch gap-2 text-grey-500 leading-4 my-0.5"
    >
      <strong className={`text-${type}-color`}>{capitalize(type)}</strong>
      {Object.entries(group)
        .filter(([, v]) => !!v)
        .map(([k, v]) => {
          if (k === "task" && v) {
            const task = parseTask(v);
            v = task[0] ?? "";
          }

          return (
            <span
              key={v}
              className={cx("truncate border-l border-gray-700 pl-2", {
                "text-[0.8em] flex-1 max-w-fit": k === "pit" && isNarrowContainer,
              })}
            >
              {k === "pit" && isNarrowContainer ? v?.slice(2) : v}
            </span>
          );
        })}
    </div>
  );

  return <SelectPopover label={label} className={cx(className)}></SelectPopover>;
};

export default ComparativeAnalysisFormSelectPopover;
